// Only shows log messages in development
// Always pass in an array of arguments
const DevLog = (args = []) => {
  if (window.APP_ENV === 'development') {
    console.log(...args)
  }
}

export default DevLog
